import { FC } from 'react';
import { AssetsTakenColumnFilterOption } from './AssetsTakenColumnFilterOption';
import './AssetTakenColumnFilterSingleValue.scss';

export const AssetTakenColumnFilterSingleValue: FC<{ option: AssetsTakenColumnFilterOption }> = ({ option }) => {
  return <div className="AssetTakenColumnFilterSingleValue">{option.label}</div>;
};
